import type {Component} from "../types.ts";
import {postAnchors} from "../worker/RenderWorkerManager.ts";
import useStore from "../store.ts";

export function updateAnchors() {
    const store = useStore();
    // see docs/EXTRACTED_COMMENTS.md#c168
    store.anchors.clear();
    Object.values(store.components).forEach((component: Component) => {
        if (component.anchor != null && component.anchor.anchor_id) {
            let anchors = store.anchors.get(component.anchor.anchor_id) || new Set();
            anchors.add(component.props.id);
            store.anchors.set(component.anchor.anchor_id, anchors);
        }
    });
    postAnchors(Object.fromEntries(store.anchors.entries()));
}

export function updateSubmitions() {
    const store = useStore();
    store.submitions.clear();
    Object.values(store.components).forEach((item) => {
        if (!item.submit_button_props?.objects) return;
        for (const submit of item.submit_button_props.objects) {
            store.submitions.set(submit.object_id, item.props.id);
        }
    })
}
